<template>
  <div id="app"
       :class="{ 'ym-in-app': isAppWebView }"
  >
    <layout v-if="errorRequest == null"></layout>
    <error-page v-else
                type="loading-error"
                hint="加载失败"
    >
      <ym-button class="retry-btn"
                 plain
                 type="primary"
                 size="small"
                 @click="handleLoadingError"
      >
        点击重试
      </ym-button>
    </error-page>
  </div>
</template>

<script>
  import { MessageBox, Button } from 'ym-mint-ui';
  import { setOrigin } from 'ym-reporter-vue';
  import { mapGetters } from 'vuex';
  import Layout from '@/layout/Layout';
  import ErrorPage from '@/components/ErrorPage';
  import {
    getAlertMessage,
    isAppWebView,
  } from '@/utils';
  import request from '@/utils/request';

  export default {
    name: 'App',
    metaInfo: {
      title: '少年商学院',
    },
    components: {
      Layout,
      ErrorPage,
      'ym-button': Button,
    },
    data() {
      return {
        isAppWebView: isAppWebView(),
      };
    },
    computed: {
      ...mapGetters([
        'errorRequest',
        'showErrorPage',
      ]),
      showConsult() {
        const { $route } = this;
        const { meta } = $route;
        return !Object.keys(meta).length || meta.showConsult == null || meta.showConsult;
      },
    },
    methods: {
      showLocationAlertMessage() {
        const message = getAlertMessage();
        if (message && message !== '') {
          MessageBox.alert(message, '', {
            confirmButtonText: '知道了',
          });
        }
      },
      handleLoadingError() {
        const { errorRequest } = this;
        if (errorRequest == null) return;
        request(errorRequest);
      },
      setAppStyle() {
        if (this.isAppWebView) document.body.classList.add('ym-in-app');
      },
    },
    created() {
      // 设置样式
      this.setAppStyle();
      // 纪录数据来源
      setOrigin();
      // 展示弹窗信息
      this.showLocationAlertMessage();
    },
  };
</script>

<style lang="less">
  @import '~@/assets/styles/index.less';

  #app {
    height: 100%;
    font-size: @font-size-base;
  }

  .retry-btn {
    margin-top: @size-medium;
    border-radius: 35px;
  }
</style>
